<div class="templateBody" *ngIf="submission" id="divToExport">
  <div class="section-line" >
    <p class="link">{{submission.requestId}}</p>
    <button class="btn btn-primary form-btn" style="margin-left:20px" (click)="showCatexForm()" data-html2canvas-ignore="true">CATEX Form</button>
    <button class="btn btn-primary form-btn" data-toggle="tooltip" title="Export Procedure with all Attached files" style="margin-left:35px" (click)="exportProcedure()" data-html2canvas-ignore="true">Export</button>
  </div>

  <!-- <p *ngIf="designer" style="font-style:italic">Submitted by {{designer?.name_email}} on
    {{submission.createdAt | date:'EEE, y-MM-dd HH:mm'}}
  </p> -->

  <!-- base -->
  <div>
    <label class="field-label">Airport:</label>
    <span>{{aptCode | mt}}</span>
  </div>
  <div>
    <label class="field-label">Airway:</label>
    <span>{{airway | mt}}</span>
  </div>
  <div>
    <label class="field-label">NAVAID:</label>
    <span>{{navAid | mt}}</span>
  </div>
  <div>
    <label class="field-label">Publication Date:</label>
    <span>{{submission.publicationDate | date:'EEEE, LLLL dd, y'}}</span>
  </div>
  <div>
    <label class="field-label">Airport Contact:</label>
    <span>{{aptContact | mt}}</span>
  </div>
  <div>
    <label class="field-label">Invite New Airport Contact Email:</label>
    <span>{{submission.airportContactEmail | mt}}</span>
  </div>

  <!-- IFP -->
  <div class="section-line">
    <label class="section-label">IFP Spec</label>
  </div>

  <div class="indent-1">
    <div>
      <label class="field-label">Procedure Request Type:</label>
      <span>{{submission.procedureRequestType}}</span>
    </div>
    <div *ngIf="isAFS">
      <label class="field-label">Public or Private:</label>
      <span>{{submission.isPrivate? 'Private':'Public'}}</span>
    </div>    
    <div>
      <label class="field-label">Single or Multiple Procedures:</label>
      <span>{{submission.isSingle? 'Single':'Multiple'}}</span>
    </div>
    <div>
      <label class="field-label">Procedure Name:</label>
      <tr *ngFor="let x of fullName">
            <span>{{x}}</span>
      </tr>
    </div>

    <!-- amended -->
    <div *ngIf="isAmended" style="margin-bottom: 10px">
      <div class="section-line">
        <label class="section-label">Specific Actions for Categorical Exclusion, in accordance with FAA Order
          1050.1</label>
      </div>

      <div class="indent-1">
        <table>
          <tr>
            <td>
              <label class="field-label-table">New or Revised:</label>
            </td>
            <td class="field-td">{{newOrRevised.length>0? newOrRevised[0]:'-'}}</td>
            <td class="field-td">{{otherExp}}</td>
          </tr>
          <tr *ngFor="let x of newOrRevised | slice:1">
            <td></td>
            <td class="field-td">{{x}}</td>
          </tr>
        </table>
        <div>
          <label class="field-label">Emergency Actions:</label>
          <span>{{submission.isMissedApproaches? 'Missed approaches and/or Missed approach holding patterns' : '-'}}</span>
        </div>

        <table>
          <tr>
            <td>
              <label class="field-label-table">Publication Actions:</label>
            </td>
            <td class="field-td">{{pubActions.length>0? pubActions[0]:'-'}}</td>
          </tr>
          <tr *ngFor="let x of pubActions| slice:1">
            <td></td>
            <td class="field-td">{{x}}</td>
          </tr>
        </table>

        <div>
          <label class="field-label">Are these the only changes to the procedure?</label>
          <span>{{submission.isOnlyChangesToProcedure? 'Yes':'No'}}</span>
        </div>
      </div>
    </div>

    <!-- procedure info -->
    <div>
      <label class="field-label">Procedure Type:</label>
      <span>{{procedureType | mt}}</span>
    </div>
    <div>
      <label class="field-label">Helicopter:</label>
      <span>{{onlyHelicopter | mt}}</span>
    </div>
    <div>
      <label class="field-label">Emergency Helicopter Route:</label>
      <span>{{emergencyHelo | mt}}</span>
    </div>
    <div>
      <label class="field-label">Procedure Altitude:</label>
      <span>{{submission.procedureAltitude | mt}}</span>
    </div>

    <!-- purpose and need -->
    <div class="section-line">
      <label class="section-label">Procedure Purpose and Need</label>
    </div>

    <!-- consensus form -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach Consensus Form:</label>
        </td>
        <td *ngIf="consensusFile.length>0" class="field-td">
          <a href="{{consensusFile[0].fileName}}?auth={{auth}}" download="{{consensusFile[0].originalFileName}}"
            class="dl-link">{{consensusFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="consensusFile.length==0" class="field-td">-</td>
      </tr>
      <tr *ngFor="let x of consensusFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
        </td>
      </tr>
    </table>

    <div>
      <label class="field-label">Procedure Description:</label>
      <tr *ngFor="let x of fullDescription">
            <span>{{x}}</span>
      </tr>
    </div>

    <div>
      <label class="field-label">Procedure Benefit:</label>
      <span [ngClass]="submission.procedureBenefit && 'indent-1 field-pre'">{{submission.procedureBenefit | mt}}
      </span>
    </div>

    <div>
      <label class="field-label">Procedure Need:</label>
      <span [ngClass]="submission.procedureNeed && 'indent-1 field-pre'">{{submission.procedureNeed | mt}}</span>
    </div>

    <!-- procedure graphic -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach Procedure Graphic:</label>
        </td>
        <td *ngIf="graphicFile.length>0" class="field-td">
          <a href="{{graphicFile[0].fileName}}?auth={{auth}}" download="{{graphicFile[0].originalFileName}}"
            class="dl-link">{{graphicFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="graphicFile.length==0" class="field-td">-</td>
      </tr>
      <tr *ngFor="let x of graphicFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
        </td>
      </tr>
    </table>

    <!-- additional documentation -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach Additional Documentation:</label>
        </td>
        <td *ngIf="additionalFile.length>0" class="field-td">
          <a href="{{additionalFile[0].fileName}}?auth={{auth}}" download="{{additionalFile[0].originalFileName}}"
            class="dl-link">{{additionalFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="additionalFile.length==0" class="field-td">-</td>
      </tr>
      <tr *ngFor="let x of additionalFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
        </td>
      </tr>
    </table>

    <!-- procedure track -->
    <div class="section-line">
      <label class="section-label">Specify Procedure Track</label>
    </div>

    <!-- kml file -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach KML File:</label>
        </td>
        <td *ngIf="kmlFile.length>0" class="field-td">
          <a href="{{kmlFile[0].fileName}}?auth={{auth}}" download="{{kmlFile[0].originalFileName}}"
            class="dl-link">{{kmlFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="kmlFile.length==0" class="field-td">-</td>
      </tr>
		<tr *ngFor="let x of kmlFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
		</td>
		</tr>
    </table>

    <div>
      <label class="field-label">Track Coordinate Input:</label>
      <span *ngIf="submission.trackCoordinateInput"
        class="indent-1 field-pre">{{submission.trackCoordinateInput | mt}}</span>
      <span *ngIf="!submission.trackCoordinateInput">{{submission.trackCoordinateInput | mt}}</span>
    </div>
  </div>

  <!-- Airport -->
  <div class="section-line">
    <label class="section-label">Airport</label>
  </div>

  <div class="indent-1">
    <div class="section-line">
      <label class="section-label">Annual Operations Counts</label>
    </div>

    <label class="section-label">Helo</label>
    <div class="indent-1">
      <div>
        <label class="field-label">Daytime (7:00am-9:59pm):</label>
        <span>{{submission.numHelicopterDayOps}}</span>
      </div>
      <div>
        <label class="field-label">Evening Ops (7:00pm-9:59pm, California Only):</label>
        <span>{{submission.numHelicopterEveningOps}}</span>
      </div>
      <div>
        <label class="field-label">Night (10:00pm-7:00am):</label>
        <span>{{submission.numHelicopterNightOps}}</span>
      </div>
    </div>

    <label class="section-label">Prop</label>
    <div class="indent-1">
      <div>
        <label class="field-label">Daytime (7:00am-9:59pm):</label>
        <span>{{submission.numPropsDayOps}}</span>
      </div>
      <div>
        <label class="field-label">Evening Ops (7:00pm-9:59pm, California Only):</label>
        <span>{{submission.numPropsEveningOps}}</span>
      </div>
      <div>
        <label class="field-label">Night (10:00pm-7:00am):</label>
        <span>{{submission.numPropsNightOps}}</span>
      </div>
    </div>


    <label class="section-label">Jets</label>
    <div class="indent-1" style="margin-bottom: 10px">
      <div>
        <label class="field-label">Daytime (7:00am-9:59pm):</label>
        <span>{{submission.numJetsDayOps}}</span>
      </div>
      <div>
        <label class="field-label">Evening Ops (7:00pm-9:59pm, California Only):</label>
        <span>{{submission.numJetsEveningOps}}</span>
      </div>
      <div>
        <label class="field-label">Night (10:00pm-7:00am):</label>
        <span>{{submission.numJetsNightOps}}</span>
      </div>
    </div>

    <table>
      <tr>
        <td>
          <label class="field-label-table">Noise Sensitive Area(s):</label>
        </td>
        <td class="field-td">{{noiseAreas.length>0? noiseAreas[0]:'-'}}</td>
      </tr>
      <tr *ngFor="let x of noiseAreas | slice:1">
        <td></td>
        <td class="field-td">{{x}}</td>
      </tr>
    </table>

    <div>
      <label class="field-label">Airport Notes:</label>
      <span [ngClass]="submission.airportContactNotes && 'indent-1 field-pre'">{{submission.airportContactNotes | mt}}
      </span>
    </div>

    <!-- airport files -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach File:</label>
        </td>
        <td *ngIf="airportFile.length>0" class="field-td">
          <a href="{{airportFile[0].fileName}}?auth={{auth}}" download="{{airportFile[0].originalFileName}}"
            class="dl-link">{{airportFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="airportFile.length==0" class="field-td">-</td>
      </tr>
      <tr *ngFor="let x of airportFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
        </td>
      </tr>
    </table>
  </div>

  <!-- Envr -->
  <div class="section-line">
    <label class="section-label">SC Env Spec</label>
  </div>

  <div class="indent-1">
    <div>
      <label class="field-label">Historic Properties:</label>
      <span>{{submission.historicProperties}}</span>
    </div>

    <div>
      <label class="field-label">Env Specialist:</label>
      <span>{{envrSpecialist | mt}}</span>
    </div>

    <div>
      <label class="field-label">SHPO Letter Date Sent:</label>
      <span>{{submission.shpoLetterDateSent | date:'EEEE, LLLL dd, y' | mt}}</span>
    </div>
      
    <div>
      <label class="field-label">Reviewed by Community Engagement Specialist:</label>
      <span>{{reviewed}}</span>
    </div>
      
    <div>
      <label class="field-label">Reviewed By:</label>
      <span>{{submission.reviewerName}}</span>
    </div>
      
    <div>
      <label class="field-label">Date Reviewed:</label>
      <span>{{submission.reviewDate | date:'EEEE, LLLL dd, y' | mt}}</span>
    </div>

    <div>
      <label class="field-label">Procedure Description for CATEX Declaration:</label>
      <!-- <span
        [ngClass]="submission.procedureDescriptionForCATEX && 'indent-1 field-pre'">{{submission.procedureDescriptionForCATEX | mt}}
      </span> -->

      <span [ngClass]="submission.procedureDescriptionForCATEX && 'indent-1 field-pre'"
        [innerHTML]="submission.procedureDescriptionForCATEX"></span>
    </div>

    <!-- envr file -->
    <table>
      <tr>
        <td>
          <label class="field-label-table">Attach File:</label>
        </td>
        <td *ngIf="envrFile.length>0" class="field-td">
          <a href="{{envrFile[0].fileName}}?auth={{auth}}" download="{{envrFile[0].originalFileName}}"
            class="dl-link">{{envrFile[0].originalFileName}}</a>
        </td>
        <td *ngIf="envrFile.length==0" class="field-td">-</td>
      </tr>
      <tr *ngFor="let x of envrFile | slice:1">
        <td></td>
        <td class="field-td">
          <a href="{{x.fileName}}?auth={{auth}}" download="{{x.originalFileName}}"
            class="dl-link">{{x.originalFileName}}</a>
        </td>
      </tr>
    </table>

    <div>
      <label class="field-label">Filter Recommendation:</label>
      <span>{{submission.FilterToolRecommendation}}</span>
    </div>

    <div>
      <label class="field-label">CATEX Eligible:</label>
      <span>{{catexEligible}}</span>
    </div>

    <table>
      <tr>
        <td>
          <label class="field-label-table">CATEX:</label>
        </td>
        <td class="field-td">{{catex.length>0? catex[0]:'-'}}</td>
      </tr>
      <tr *ngFor="let x of catex | slice:1">
        <td></td>
        <td class="field-td">{{x}}</td>
      </tr>
    </table>

    <div>
      <label class="field-label">Notes:</label>
      <span
        [ngClass]="submission.environmentalSpecialistNotes && 'indent-1 field-pre'">{{submission.environmentalSpecialistNotes | mt}}
      </span>
    </div>

  </div>

  <div>
    <label class="field-label">Current Form Editor:</label>
    <span>{{submission.workflowState}}</span>
  </div>

  <div>
    <label class="field-label">Procedure Map</label>
    <div class="map-div" style="margin-bottom:15px;" #mapDiv></div>
  </div>

  <div class="section-line">
    <label class="section-label"  data-html2canvas-ignore="true">Comments</label>
  </div>

  <div [formGroup]="commentForm" class="form-group"  data-html2canvas-ignore="true">
    <label>Add new comment</label>
    <textarea class="form-control" rows="4" formControlName="commentMessage"></textarea>
  </div>

  <button type="submit" class="btn btn-primary form-btn" [disabled]="!hasComment()" (click)="saveComment()"  data-html2canvas-ignore="true">
    Save</button>
  <button type="button" class="btn btn-primary form-btn" style="margin-left:10px"
    (click)="cancelComment()"  data-html2canvas-ignore="true">
    Cancel</button>

  <div class="section-line">
    <label class="section-label"  data-html2canvas-ignore="true">Revision Log</label>
  </div>

  <div style="margin-top: 15px; margin-bottom: 15px">
    <p-table [columns]="cols" [value]="commentLogs" *ngIf="showLog">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="text-align:center" [ngStyle]="{'width':col.width}" *ngFor="let col of columns"
            [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log let-columns="columns">
        <tr>
          <td *ngFor="let col of columns; let i = index" [ngClass]="(i==1) && 'grid-align-left'">
            <span *ngIf="!col.isDate" [innerHTML]="replaceNewlines(log[col.field])"></span>
            <span *ngIf="col.isDate">{{ log[col.field] | date:'EEE, y-MM-dd HH:mm' }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>